import React, { Component } from 'react';
import { Col, FormGroup, FormControl, Row, Radio } from 'react-bootstrap';

import { updateProfessionalInfo } from '../actions';

class WorkExperience extends Component {
  constructor(props){
    super(props);
    this.handleHoursChange = this.handleHoursChange.bind(this);
    this.handleEmployerChange = this.handleEmployerChange.bind(this);
    this.handleOtherChanges = this.handleOtherChanges.bind(this);
  }

  handleHoursChange(e){
    const { professionalInfo, type } = this.props;
    const hasWorkHours = e.target.value === "Y";
    const updates = {
      workExperience: {
        ...professionalInfo.workExperience,
      }
    };
    updates.workExperience[type] = {
      ...professionalInfo.workExperience[type],
      hasWorkHours
    };
    // DynamoDB hates empty strings so we delete the attribute when not used
    if(hasWorkHours)
      updates.workExperience[type].employer = '';
    else
      delete updates.workExperience[type].employer;
    this.handleOtherChanges(updates);
  }

  handleEmployerChange(e){
    const { professionalInfo, type } = this.props;
    const updates = {
      workExperience: {
        ...professionalInfo.workExperience
      }
    };
    updates.workExperience[type] = {
      ...this.props.professionalInfo.workExperience[type],
      employer: e.target.value
    };
    this.handleOtherChanges(updates);
  }

  handleOtherChanges(updates){
    const { dispatch } = this.props;
    dispatch(updateProfessionalInfo(updates));
  }

  render() {
    const { professionalInfo, type } = this.props;
    const space = ' ';
    const hasWorkHours = typeof professionalInfo.workExperience[type] === 'undefined' ?
      false : professionalInfo.workExperience[type].hasWorkHours;
    const employer = typeof professionalInfo.workExperience[type] === 'undefined' ?
      '' : professionalInfo.workExperience[type].employer;
    return (
      <Row>
        <Col sm={12}>
          <h4>Work Experience</h4>
          <p><strong>Do you have 1000+ hours of experience or work experience for your {type}(s)?</strong></p>
          <FormGroup
            controlId={type + '-work-experience-hours'}
          >
            <Radio
              name={type + '-hours'}
              inline
              onChange={this.handleHoursChange}
              value="Y"
              checked={hasWorkHours}
            >
              Yes
            </Radio>
            {space}
            <Radio
              name={type + '-hours'}
              inline
              onChange={this.handleHoursChange}
              value="N"
              checked={!hasWorkHours}
            >
              No
            </Radio>
          </FormGroup>
          { hasWorkHours &&
            <div>
              <p><strong>Please list current/former employer:</strong></p>
              <FormGroup
                controlId={type + '-work-experience-employer'}
              >
                <FormControl
                  componentClass="input"
                  type="text"
                  value={employer}
                  placeholder="Enter Employer"
                  onChange={this.handleEmployerChange}
                />
                <FormControl.Feedback />
              </FormGroup>
            </div>
          }
        </Col>
      </Row>
    );
  };
}

export default WorkExperience;